import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <Layout>
      <Seo title="Page not found — CompuBrain Knowledge Base" description="The page you are looking for does not exist." path="/404" />
      <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="notfound">
        <Compass className="mx-auto mb-4 text-[var(--gov-blue)]" size={44} />
        <h1 className="mb-2 text-3xl font-bold text-[var(--navy)]">404 — Not found</h1>
        <p className="mb-6 text-[var(--muted)]">This page doesn't exist. Explore the knowledge base instead.</p>
        <div className="flex justify-center gap-3">
          <Link to="/" className="rounded-[4px] bg-[var(--navy)] px-4 py-2 font-semibold text-white no-underline hover:bg-[var(--gov-blue)]">Home</Link>
          <Link to="/categories" className="rounded-[4px] border border-[var(--line)] px-4 py-2 font-semibold text-[var(--ink-soft)] no-underline hover:bg-[var(--bg-alt)]">Browse categories</Link>
        </div>
      </div>
    </Layout>
  );
}
